import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import AtomButton from '@/components/Atoms/Buttons/AtomButton.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonRounded',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AtomButton, { class: "rounded min-w-[150px]" }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})